import { createSelector } from 'reselect';

const selectMusics = ({ music }) => music;

export const selectIsFetchingMusic = createSelector(
    [selectMusics],
    ({ isFetching }) => isFetching
);

export const selectSongs = createSelector(
    [selectMusics],
    ({ songs }) => songs 
);

export const selectIsPlaying = createSelector(
	[selectMusics],
	({ isPlaying  }) => isPlaying
)
